export default class GuessPigments {

    constructor() {
        this.settings = {
            lowChroma: 5,
            middleChroma: 60,
            highChroma: 90,
            lowValue: 15,
            middleValue: 40,
            pureValue: 70, // Pigment Straight from Tube
            highValue: 80,
            ro: 7,
            o: 18,
            oy: 36,
            y: 47,
            gy: 62,
            g: 100,
            gb: 148,
            b: 172,
            bp: 245,
            p: 260,
            pr: 285,
            r: 338
        };
    }

    /**
     * Use standard graph quadrant
     * 
     * @param {int} h Hue
     * @param {int} s Saturation
     * @param {int} v Value
     */
    getColorQuadrant(h, s, v) {
        if (v <= this.settings.lowValue) {
            return 7;
        }

        if (s <= this.settings.lowChroma) {
            if (v <= 95) {
                return 1;
            } else if (v > 95) {
                // Basically just White
                return 0;
            }
        } else if (s <= this.settings.middleChroma) {
            if (v <= this.settings.middleValue) {
                return 5;
            } else if (v > this.settings.middleValue && v <= 95) {
                return 2;
            } else if (v > 95) {
                return 4;
            }
        } else if (s > this.settings.highChroma && (v >= this.settings.pureValue && v < this.settings.highValue)) {
            // Pigment Straight from Tube
            return 8;
        } else if (s > this.settings.middleChroma) {
            if (v <= this.settings.middleValue) {
                return 6;
            } else if (v > this.settings.middleValue) {
                if (
                    // Reds, Yellow, Orange (Not Rows 1)
                    ((h <= this.settings.gy || h >= this.settings.r) && (v < 95)) ||
                    // Green, Blue, Purple (Not Rows 1 and 2)
                    ((h > this.settings.gy && h < this.settings.r) && (v < 90))) {
                    return 3;
                } else {
                    // Top One - Two rows of Quad 3
                    return 4;
                }
            }
        }

        // Default
        return 1;
    }

    /**
     * Get Hue Pigments
     * 
     * @param {int} hue Hue
     * @param {int} quadrant Quadrant
     * @param {int} saturation Saturation
     * @param {int} value Value
     * 
     * @return {object} hue Hues
     */
    getHuePigments(hue, quadrant, saturation, value) {
        if (quadrant === 1 || quadrant === 7) {
            // None
            return {};
        }

        if (hue <= this.settings.ro) {
            return {
                'Cadmium Red': '#ff0000'
            }
        } else if (hue > this.settings.ro && hue <= this.settings.o) {
            return {
                'Cadmium Red': '#ff0000',
                'Cadmium Orange': '#ffa500',
            }
        } else if (hue > this.settings.o && hue <= this.settings.oy) {
            return {
                'Cadmium Orange': '#ffa500',
            }
        } else if (hue > this.settings.oy && hue <= this.settings.y) {
            if (value <= this.settings.pureValue || (saturation <= 30 && value < 90)) {
                return {
                    'Cadmium Orange': '#ffa500',
                    'Yellow Ochre': '#ffff00',
                }
            } else {
                return {
                    'Cadmium Orange': '#ffa500',
                    'Cadmium Yellow': '#ffff00',
                }
            }
        } else if (hue > this.settings.y && hue <= this.settings.gy) {
            if (value <= this.settings.pureValue || (saturation <= 30 && value < 90)) {
                return {
                    'Yellow Ochre': '#ffff00',
                }
            } else {
                return {
                    'Cadmium Yellow': '#ffff00',
                }
            }
        } else if (hue > this.settings.gy && hue <= this.settings.g) {
            if (value <= this.settings.pureValue || (saturation <= 30 && value < 90)) {
                return {
                    'Sap Green': '#008000',
                    'Yellow Ochre': '#ffff00'
                }
            } else {
                return {
                    'Sap Green': '#008000',
                    'Cadmium Yellow': '#ffff00'
                }
            }
        } else if (hue > this.settings.g && hue <= this.settings.gb) {
            return {
                'Sap Green': '#008000',
            }
        } else if (hue > this.settings.gb && hue <= this.settings.b) {
            return {
                //'Sap Green': '#008000',
                //'Cobalt Blue': '#0000ff'
                'Turquoise': '#00ffb2'
            }
        } else if (hue > this.settings.b && hue <= this.settings.bp) {
            return {
                'Cobalt Blue': '#0000ff'
            }
        } else if (hue > this.settings.bp && hue <= this.settings.p) {
            return {
                'Cobalt Blue': '#0000ff',
                'Cobalt Violet': '#4b0082'
            }
        } else if (hue > this.settings.p && hue <= this.settings.pr) {
            return {
                'Cobalt Violet': '#4b0082'
            }
        } else if (hue > this.settings.pr && hue <= this.settings.r) {
            return {
                'Alizarin Crimson': '#ff00ff',
                'Cobalt Violet': '#4b0082'
            }
        } else if (hue > this.settings.r) {
            return {
                'Alizarin Crimson': '#ff00ff'
            }
        }

        return {};
    }

    /**
     * Get Neutral Pigments
     * 
     * @param {int} hue Hue
     * @param {int} quadrant Quadrant
     * @param {int} value Value
     */
    getNeutralPigments(hue, quadrant, value, saturation) {
        let pigments = {};
        let darkQuadrants = [2, 3, 5, 6, 7];
        let whiteQuadrants = [2, 3];


        // Exceptions
        if (quadrant === 0) {
            return {
                'Titanium White': '#ffffff'
            }
        } else if (quadrant === 1) {
            return {
                'Raw Umber': '#05052e',
                'Titanium White': '#ffffff'
            }
        } else if (quadrant === 7) {
            return {
                'Ivory Black': '#000000',
            }
        } else if (quadrant === 4) {
            return {
                'Titanium White': '#ffffff'
            }
        } else if (quadrant === 8) {
            // Pigment Straight from Tube
            return {};
        }

        // Get Darks
        if (darkQuadrants.includes(quadrant)) {
            if (hue <= 173 || hue >= 317) {
                // R, P
                pigments['Raw Umber'] = '#05052e';
            } else if (hue > 173 && hue <= 285) {
                // B, G
                pigments['Ivory Black'] = '#000000';
            } else if (hue > 285 && hue <= 317) {
                // G, Y, O, R
                pigments['Raw Umber'] = '#05052e';
            }
        }

        // Determine if White
        if (whiteQuadrants.includes(quadrant)) {
            pigments['Titanium White'] = '#ffffff';
        }

        return pigments;
    }
}